import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ThirdPartsAuthenticationList } from '~modules/thirdparts/common/entities/third-parts-authentication-list.entity';
import { ThirdPartsGoCardlessAuthenticationManualCreateUpdateRequest } from '../entities/third-parts-gocardless-authentication-manual-create-update-request.entity';
import { environment } from 'src/environments/environment';

@Injectable()
export class ThirdPartsGoCardlessAuthenticationService {

  constructor(private readonly http: HttpClient) { }

  public list$(): Observable<ThirdPartsAuthenticationList[]> {
    const path = `${environment.apiURL}/third-parts/gocardless/authentication/list`;
    return this.http.get<ThirdPartsAuthenticationList[]>(path);
  }

  public createOrUpdate$(request: ThirdPartsGoCardlessAuthenticationManualCreateUpdateRequest) {
    const url = `${environment.apiURL}/third-parts/gocardless/authentication`;

    return this.http.post<void>(url, request);
  }
}
